<template>
  <tr>
    <th v-for="(head, index) in heads" :key="index">
      {{head}}
    </th>
  </tr>
</template>
<script>

export default {
  props: {
    heads: Array
  },
}
</script>
